import type { FunctionComponent } from 'react';
import { getDropship, getPending, getShipped } from '../../utils/orders';
import DesktopProductList from './DesktopProductList';
import MobileItems from './MobileItems';

type ProductsListProps = {
  order: Record<string, unknown>;
  isDesktop: boolean;
  trackShipment: (order: Record<string, unknown>, trackingNumber: string) => void;
};

const ProductsList: FunctionComponent<ProductsListProps> = ({
  order,
  isDesktop,
  trackShipment,
}) => {
  const { shipments } = order;
  const shipped = getShipped(shipments);
  const pending = getPending(shipments);
  const dropship = getDropship(shipments);
  const handleClickTrackShipment = (trackingNumber: string) => trackShipment(order, trackingNumber);

  if (isDesktop) {
    return (
      <DesktopProductList
        shipped={shipped}
        pending={pending}
        dropship={dropship}
        trackShipment={handleClickTrackShipment}
      />
    );
  }
  return <MobileItems shipments={shipments} />;
};

export default ProductsList;
